import * as React from "react";
const SvgHierarchy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="hierarchy_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path
      fill="#333"
      d="M537.6 700.032h64a64 64 0 0 1 64 64V896a64 64 0 0 1-64 64H422.4a64 64 0 0 1-64-64V763.968a64 64 0 0 1 64-64h64V532.032h-256a51.52 51.52 0 0 0-50.88 45.888l-.32 6.08-.064 115.968H243.2a64 64 0 0 1 64 64V896a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V763.968a64 64 0 0 1 64-64h64V584c0-57.408 45.824-104 102.4-104h563.2c56.576 0 102.4 46.592 102.4 104v115.968h64a64 64 0 0 1 64 64V896a64 64 0 0 1-64 64H780.8a64 64 0 0 1-64-64V763.968a64 64 0 0 1 64-64h63.936L844.8 584a51.584 51.584 0 0 0-51.2-52.032h-256v168.064zM224 752H83.2a32 32 0 0 0-31.488 26.24L51.2 784v92.032a32 32 0 0 0 26.24 31.424l5.76.512H224a32 32 0 0 0 31.488-26.24l.512-5.76V784a32 32 0 0 0-32-32zm358.4 0H441.6a32 32 0 0 0-31.488 26.24L409.6 784v92.032a32 32 0 0 0 26.24 31.424l5.76.512h140.8a32 32 0 0 0 31.488-26.24l.512-5.76V784a32 32 0 0 0-32-32zm358.4 0H800a32 32 0 0 0-31.488 26.24L768 784v92.032a32 32 0 0 0 26.24 31.424l5.76.512h140.8a32 32 0 0 0 31.488-26.24l.512-5.76V784a32 32 0 0 0-32-32zm-288-688a64 64 0 0 1 64 64v184a64 64 0 0 1-64 64H537.6v104h-51.2V376H371.2a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h281.6zm-19.2 52.032H390.4a32 32 0 0 0-31.488 26.24l-.512 5.76v144a32 32 0 0 0 26.24 31.424l5.76.512h243.2a32 32 0 0 0 31.488-26.24l.512-5.76v-144a32 32 0 0 0-32-32z"
    />
  </svg>
);
export default SvgHierarchy;
